import {FormGroup, Validators} from "@angular/forms";

export class CheckedComponentInternal {
  campaignForm: FormGroup | undefined;
  ref: string;
  crossRefChecked: string | undefined;
  checkRef: string;
  private prevVal: null = null;
  public enabledValue = "";
  public disabledValue = "";

  constructor(ref: string, crossRef?: string) {
    this.ref = ref;
    this.checkRef = this.ref + "Checked";
    if (crossRef) {
      this.crossRefChecked = crossRef + "Checked";
    }
  }

  init(campaignForm: FormGroup) {
    this.campaignForm = campaignForm;

    if (this.crossRefChecked) {
      this.campaignForm?.get(this.crossRefChecked)?.valueChanges.subscribe(val => {
        if (this.prevVal !== val) {
          this.checkboxClicked();
        }
        this.prevVal = val;
      });
    }
  }

  initChecked(initValue: string): void {
    this.campaignForm?.get(this.ref)?.setValue(initValue);
    this.disabledValue = initValue;
    this.campaignForm?.get(this.ref)?.disable();
    this.campaignForm?.get(this.checkRef)?.setValue(true);
  }

  checkboxClicked(): void {
    let theControl = this.campaignForm?.get(this.ref);
    const enabled = theControl?.enabled;
    if (enabled) {
      this.enabledValue = theControl?.value || "";
      theControl?.disable();
      theControl?.setValue(this.disabledValue);
      theControl?.clearValidators();
    } else {
      theControl?.enable();
      theControl?.setValue(this.enabledValue);
      const validators = [Validators.required];
      if (this.ref.indexOf("mail") > -1) {
        validators.push(Validators.email);
      }
      theControl?.setValidators(validators);
    }
    theControl?.updateValueAndValidity();
  }
}


